import { createFileRoute } from "@tanstack/react-router";

import { LongTermAssets } from "~/components/feature/balance/components";

export const Route = createFileRoute(
  "/_app/dashboard/balance/long-term-assets/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <LongTermAssets />;
}
